const editFAQsConstantsAr = {
  FAQsPageTitle: 'الأسئلة الشائعة',
  FAQsPageBreadcrumb: 'الأسئلة الشائعة',
};

export default editFAQsConstantsAr;
